export const financeRoutes = [
  {
    path: '/finance/finance-profit-report',
    component: () => import('@/views/modules/finance/finance-profit-report/finance-profit-report'),
    meta: { name: '利润报表', keepAlive: true, permission: 'profitReport:view' ,modal:'财务'}
  },
  {
    path: '/finance/cost-center',
    component: () => import('@/views/modules/finance/cost-center/cost-center'),
    meta: { name: '成本中心', keepAlive: true, permission: 'financialMonthCost:view' ,modal:'财务'}
  },
  {
    path: '/finance/remittance-record',
    component: () => import('@/views/modules/finance/remittance-record/remittance-record'),
    meta: { name: '回款报告', keepAlive: true, permission: 'returnedReport:view'  ,modal:'财务'}
  },
  {
    path: '/finance/deduction-record',
    component: () => import('@/views/modules/finance/deduction-record/deduction-record'),
    meta: { name: '扣减记录', keepAlive: true, permission: 'storageCostBatchConsume:view'  ,modal:'财务'}
  },
  {
    path: '/finance/batch-management',
    component: () => import('@/views/modules/finance/batch-management/batch-management'),
    meta: { name: '批次管理', keepAlive: true, permission: 'storageCostBatch:view'  ,modal:'财务'}
  },
  {
    path: '/finance/performance-report',
    component: () => import('@/views/modules/finance/performance-report/performance-report'),
    meta: { name: '业绩报告', keepAlive: true, permission: 'performanceReport:view'  ,modal:'财务'}
  },
];
